import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import ButtonExportModel from '../components/PropertiesPaneButtonExportModel.jsx'
import ModulePropertiesPane from '../_MODULE/ModulePropertiesPane.jsx'
import ButtonGenerateBd from '../FA/PropertiesPaneButtonGenerateBd.jsx'
import ButtonGenerateCc from '../BD/PropertiesPaneButtonGenerateCc.jsx'
import Model from './ModelFm.mjs'

import {
    PropertiesPaneButtonExportReq as ButtonExportReq,
    PropertiesPaneButtonExportReq2 as ButtonExportReq2,
} from './PropertiesPaneButtonExportReq.jsx'

import ButtonGenerateRam from './PropertiesPaneButtonGenerateRam.jsx'

import {
    PropertiesPaneButtonIntegrateMap as ButtonIntegrateMap,
    PropertiesPaneButtonClearMap as ButtonClearMap,
} from './PropertiesPaneButtonIntegrateMap.jsx'

const PropertiesPaneFm = (props) => (
    <ModulePropertiesPane
        buttons={
            <>
                <ButtonExportModel type="fm" />
                <ButtonExportModel type="bdlogic_excel" />
                <ButtonGenerateBd />
                <ButtonGenerateRam />
                <ButtonIntegrateMap />
                <ButtonClearMap />
                <ButtonExportReq />
                <ButtonExportReq2 />
                <ButtonGenerateCc />
            </>
        }

        controllers={
            <>
                <Text prop="fmUserCode" />
                <Text prop="fmName" />
                <LongText prop="fmDesc" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        versionLabel="功能地图版本号"
        {...props}
    />
)

export default PropertiesPaneFm
